import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SabCircularProgress } from "web_myplann/Shared/Progresses";

type Props = {
	loading: boolean;
	onClick: () => void;
};

export const LoadNextRow: FC<Props> = ({ loading, onClick }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			height={40}
			direction="row"
			alignItems="center"
			gap={0.5}
			onClick={loading ? undefined : onClick}
		>
			{loading ? (
				<SabCircularProgress size="sm" />
			) : (
				<ChevronDown color={theme.palette.primary.main} />
			)}
			<Typography variant="bodyStrong" color={theme.palette.primary.main}>
				{t(Resources.Common.LoadNext)}
			</Typography>
		</Stack>
	);
};
